export const getErrorMessage = (error, fallback = "Something went wrong") => {
    if (!error) return fallback;

    // Case 1: error is already an Error object
    if (error instanceof Error) {
        try {
            const parsed = JSON.parse(error.message);
            return parsed?.message || fallback;
        } catch {
            return error.message || fallback;
        }
    }

    // Case 2: error is plain object
    if (typeof error === "object") {
        return error.message || fallback;
    }

    return fallback;
};
